import React from 'react';
import PropTypes from 'prop-types';
import { ListItem } from '@sm/wds-react';

import '../mobile-menu-anon.scss';

export const Menu = ({ title, url }) => {
  return (
    <ListItem
      key={`${title}-non-nested`}
      className="sm-mobile-menu-anon__anchor"
      isNavigable
      navigationTarget={url}
    >
      {title}
    </ListItem>
  );
};

Menu.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string,
};

Menu.defaultProps = {
  url: null,
};

export default Menu;
